import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
// import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { IEnclosedAreaFileView } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'enclosedAreaAttachment',
  styleUrls: ['./enclosedAreaAttachment.component.scss'],
  templateUrl: './enclosedAreaAttachment.component.html'
})

export class EnclosedAreaAttachmentComponent implements OnInit {

  filesList: IEnclosedAreaFileView[] = [];
  isAdmin: boolean = false;
  state: string = '';

  displayedColumns: string[] = ['fileName', 'user', 'date', 'action'];
  dataSource = new MatTableDataSource<IEnclosedAreaFileView>(this.filesList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  // ids: boolean = false;

  form = new UntypedFormGroup({
    visitDate: new UntypedFormControl(''),
    comments: new UntypedFormControl(''),
  });

  constructor(
    private sharedService: SharedService,
    private authService: AuthService,
    private complaintService: ComplaintService,
    private dialogRef: MatDialogRef<EnclosedAreaAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.filesList != null && this.data.filesList != undefined) {
      this.filesList = this.data.filesList;
      this.dataSource.data = this.filesList;
    }
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin;
    this.state = '';
  }

  getFile(attachmentFile: IEnclosedAreaFileView): void {

    this.complaintService.getEnclosedAreaFile(attachmentFile.id).subscribe(
      (result) => {
        this.sharedService.downloadFile(attachmentFile.name, result);
      },
      error => {
        this.sharedService.toastr.error("Could not get File: " + error.message);
      }
    );
  }

  delete(attachmentFile: IEnclosedAreaFileView): void {
    this.sharedService.openConfirm("Are you sure you want to delete this file?");

    this.sharedService.confirmed().subscribe(
      confirmed => {

        this.complaintService.deleteEnclosedAreaFile(attachmentFile.id).subscribe(
          (result) => {
            this.filesList = this.filesList.filter(x => x.id != attachmentFile.id);
            this.dataSource.data = this.filesList;
            this.state = 'deleted';
            this.sharedService.toastr.success("File Deleted Successfully");
          },
          error => {
            this.sharedService.toastr.error("Could not get File: " + error.message);
          }
        );
      }
    );
  }

  return(): void {
    this.dialogRef.close(this.state);
  }
}